<div class="container  mt-5  text-center">
  <div class="wrapper m-auto">
  <div *ngIf="!statusChecked">
    <h3 class="mb-4">Перевіряємо статус оплати</h3>
    <p class="mb-3">Будь ласка зачекайте</p>
    <ngb-progressbar [height]="'4px'" [striped]="true" [animated]="true" [value]="statusValue"></ngb-progressbar>
  </div>

  <div *ngIf="error && statusChecked">
    <h3 >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
           class="bi bi-check-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        <path
          d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
      </svg>
      {{error}}</h3>
    <p>Перевірте ще раз або спробуйте пізніше</p>

    <div class="mt-3 d-flex justify-content-between">
      <button class="btn btn-primary" (click)="checkStatus()">Перевірити ще раз</button>
      <button class="btn btn-link" (click)="goTo('/')">Повернутись на головну</button>
    </div>
  </div>
</div>
</div>
